<template>
  <base-dialog
    @save-item="saveItem"
    dialogId="create-portal-model-dialog"
    :open.sync="openDialog"
    :form-ref.sync="portalModelFormRef"
    :loading.sync="isLoading"
  >
    <template v-slot:[`dialog.title`]>
      <span>Créer un modèle de portail</span>
    </template>
    <template v-slot:[`dialog.content`]>
      <v-container>
        <portal-model-form
          :portal-model-form.sync="portalModelForm"
          :rules="rules"
        ></portal-model-form>
      </v-container>
    </template>
    <template v-slot:[`dialog.actions.save`]>Créer</template>
  </base-dialog>
</template>
<script>
import { toRefs, computed } from "@vue/composition-api";
import PortalModelForm from "@/components/PortalModel/PortalModelForm";
import { usePortalModel } from "@/composables/portal-model";
import BaseDialog from "@/components/General/BaseDialog.vue";

export default {
  components: {
    PortalModelForm,
    BaseDialog,
  },
  props: {
    open: Boolean,
  },
  setup(props, { emit }) {
    /* Import des API */
    const { portalModelData, createPortalModel } = usePortalModel();

    /* Computed */
    const openDialog = computed({
      get: function () {
        return props.open;
      },
      set: function (value) {
        emit("update:open", value);
      },
    });

    /* Méthodes */
    const saveItem = async function () {
      await createPortalModel();
      openDialog.value = false;
    };

    return {
      createPortalModel,
      ...toRefs(portalModelData),
      openDialog,
      saveItem,
    };
  },
};
</script>
